import axios from "axios";

export const getListCard = (headers, params) => {
  return axios.get(
    `${process.env.REACT_APP_BACKEND_API_URL}/auth/get-list-card`,
    {
      headers,
      params,
    }
  );
};

export const getCardById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_BACKEND_API_URL}/auth/get-card/${id}`,
    { headers }
  );
};

export const getTrackingLink = (headers, productId) => {
  return axios.get(
    `${process.env.REACT_APP_BACKEND_API_URL}/auth/by-product/${productId}`,
    { headers }
  );
};
